import { css } from '@emotion/core';
import { styled, minimumWidth } from '@feast-it/ui/light';

export const Container = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing[4]};
  `
);

export const ButtonWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.spacing[2]};
    flex-direction: column;

    a,
    button {
      justify-content: center;
    }

    ${minimumWidth(theme.breakpoints.small)} {
      flex-direction: row;

      a,
      button {
        justify-content: flex-start;
      }
    }
  `
);
